var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-tasks text-h5 pa-3"},[_c('v-icon',{attrs:{"large":"","color":"lighten-1"}},[_vm._v("mdi-smoking")]),_vm._v(" Cool! The work is done ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }